/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * content object
 * @export
 * @interface GetCharactersCharacterIdPlanetsPlanetIdContent
 */
export interface GetCharactersCharacterIdPlanetsPlanetIdContent {
    /**
     * amount integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdContent
     */
    amount: number;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdContent
     */
    typeId: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdPlanetsPlanetIdContent interface.
 */
export function instanceOfGetCharactersCharacterIdPlanetsPlanetIdContent(value: object): value is GetCharactersCharacterIdPlanetsPlanetIdContent {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdPlanetsPlanetIdContentFromJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdContent {
    return GetCharactersCharacterIdPlanetsPlanetIdContentFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdPlanetsPlanetIdContent {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'typeId': json['type_id'],
    };
}

export function GetCharactersCharacterIdPlanetsPlanetIdContentToJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdContent {
    return GetCharactersCharacterIdPlanetsPlanetIdContentToJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdContentToJSONTyped(value?: GetCharactersCharacterIdPlanetsPlanetIdContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'type_id': value['typeId'],
    };
}

